//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import styled from 'styled-components';

//  -- Components ---------------------
import { Dropdown } from 'antd';

//  -- Constants ----------------------
import { Button } from '@mui/material';
import ResizeAndDragabble from "components/ResizeAndDraggableWidget";

import { Snackbar } from '@mui/material';
import {
  Close,
  KeyboardArrowDown,
  KeyboardArrowUp,
} from '@mui/icons-material';
import { Alert } from '@mui/material';
import { filter, find, get, has } from 'lodash';
import { useDispatch } from 'react-redux';
import { useCurrentClass } from 'store/classes/selectors';
import { useCurrentUser } from 'store/users/selectors';
import { useAudio } from 'utils/context/AudioProvider';
import { setAudioChecker } from 'store/audio/actions';
import {
  handleListVocabularyCogantes,
  handleListVocabularyCogStud,
} from 'store/cogantes/thunks';
import Cogantes from '../../../../components/ebook/cogantes';
import { useExams } from 'store/exams/selectors';
import QnALoader from '../../../../components/VocabQnAModal/QnALoader';
import { useCognets } from 'store/cogantes/selectors';
import CognateAiLoader from '../../../../components/ebook/cogantes/cognateAiModal';
import { useOrientation } from '../../../../components/hooks';
import { question_type_generate_more } from 'utils/config/reference';
import { useClassUsers } from 'store/userClasses/selectors';
import { useAllBook, useBookOrder } from 'store/books/selectors';
import VocabPrint from 'modules/PrintVocabulary/VocabPrint';
import { useLocation } from 'react-router-dom';
import { useMobileDetect } from 'hooks/useMobileDetect';
import * as Sentry from '@sentry/react';
import { useAlert } from '../../../../components/UI/alertSakeBar/alertProvider';
import { useConfirm } from '../../../../components/UI/confirmProvider';
import { handleStreamResponse } from 'utils/methods/QuestionCreateStreamHandle';
import { handleStreamResponseForCognates } from 'utils/methods/CognatesStreamHandler';
import { createVocabularySuccessCogantes } from 'store/cogantes/actions';
import { ItemLoader } from 'components/Loader/ItemLoader';
import { handleGetStudentWordCount } from 'store/vocabulary/thunks';
import useBook from 'components/hooks/books/useBook';
import Loading from 'components/Loading';
import { useClassTogglePermission, useCurrentOrgPermission } from 'store/organizations/selectors';
import { useIsAdditionalBook } from 'utils/methods/functions';
import { useUserProfileConfig } from 'store/users/selectors';
import SentryWrap from 'components/Sentry';
import AIUsageInfo from 'components/Modals/AiInfoModal';

const CrossPrint = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 8px;
  width: 100px;
`;
const LoaderArea = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 92px;
  top: 8px;
  z-index: 99999;
`;
const ModalContent = styled.div`
   position: relative;
   border-radius: 10px;
   background-color: #fff;
   padding: 10px;
   height: 100%;
   width: 100%;
   overflow: visible;
   display: flex;
   flex-direction: column;
   z-index: 999999999;
 `;

const CustomMenuItem = styled.div`
  background: #f5a623;
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  margin: 5px;
  text-align: right;
  cursor: pointer;

  &:hover {
    background: #e0911e;
  }
`;

const CustomMenuItem2 = styled.div`
  background: rgb(16, 44, 110);
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  margin: 5px;
  text-align: right;
  cursor: pointer;

  &:hover {
    background: rgb(16, 44, 110);
  }
`;

const CreateQuestionAndAnswerForAICogantes = ({
  data,
  addNewItem,
  toogleChange,
}) => {
  const menu = {
    items: [
      {
        key: 'english',
        label: (
          <CustomMenuItem
            onClick={() => {
              toogleChange('cognates_ai');
              addNewItem('english');
            }}
          >
            AI Act. with Cognates in English
          </CustomMenuItem>
        ),
      },
      {
        key: 'spanish',
        label: (
          <CustomMenuItem2
            onClick={() => {
              toogleChange('cognates_ai');
              addNewItem('spanish');
            }}
          >
            AI Act. with Cognates in Spanish
          </CustomMenuItem2>
        ),
      },
    ],
  };

  return (
    <Dropdown 
      menu={menu} 
      trigger={['click']} 
      placement="bottomLeft" 
      overlayClassName="aiAct-dropdown"
      overlayStyle={{ zIndex: 1000000001 }}
      getPopupContainer={() => document.body}
    >
      {get(data?.currentUser, 'role') === 'teacher' ? (
        !data?.isExam &&
        !data?.isOnlyForTeacher && <Button className="minWith">AI Act. with Cognates</Button>
      ) : (
        <></>
      )}
    </Dropdown>
  );
};
const CognatesNonSpanishComponent = ({
  pageId,
  isCheckingOpen,
  bookId,
  style,
  vocabilaryButtonClassName = '',
  isOnlyForTeacher = false,
  pageNumber,
  setVocModal,
  closeToolsDropdown
}) => {
  const showAlert = useAlert();
  const confirm = useConfirm();
  const location = useLocation();
  const currentUser = useCurrentUser();
  const currentClass = useCurrentClass();
  const classUsers = useClassUsers();
  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const dispatch = useDispatch();
  const allBooks = useAllBook();
  const book = useMemo(() => find(allBooks ?? [], ['id', bookId]), [allBooks, bookId]);
  const [openVocabulary, setVocabulary] = useState(false);

  const [studentCognates, setStudentCognates] = useState([]);
  const [vocLoader, setVocLoader] = useState(false);
  const [tabSelector, setTabSelector] = useState({ type: 'congantes' });
  const [selectedWordCogantes, setSelectedWordCogantes] = useState([]);
  const tabSelectorTypeRef = useRef(tabSelector?.type);
  const [selectedTypes, setSelectedTypes] = useState(
    question_type_generate_more.map((option) => option.value),
  );

  const isMobile = useMobileDetect();
  const [visible, setVisible] = useState(false);
  const vocabdomRef = useRef();
  const [generatedCount,SetGenerateCount] = useState(0)
  const questionRequestIdRef = useRef(0);
  // for ai
  const exams = useExams();
  const isExam = useMemo(
    () =>
      exams?.flatMap((entry) => entry.exams.map((exam) => `${exam.bookId}`)).includes(`${bookId}`),
    [exams],
  );
  const [assignmentAiModal, setAssignmentAiModal] = useState(false);
  const [generateQnALoader, setGenerateQnALoader] = useState(false);
  const [questionGenerator, setQuestionGenerator] = useState([]);
  const [qnaWord, setQnAWord] = useState('');
  const [questionLoader, setQuestionLoader] = useState(false);
  const [selectedAIVocab, setSelectedAIVocab] = useState([]);
  const [wordLanguage, setWordLanguage] = useState('english_to_spanish');
  const [studentWordCounts, setStudentWordCounts] = useState([]);
  const [loading,setLoading]= useState(false);
  const [showAccordin, setShowAccordin] = useState(true);
  const [dimensions, setDimensions] = useState({});
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  // const generated_question = useMemo(
  //   () => questionGenerator.map((k) => ({ ...k, id: Math.random() * 1000000000 })),
  //   [questionGenerator],
  // );
  const bookCognets = useCognets();
  const [aiModal, setAiModal] = useState(false);
  const isLandscape = useOrientation();
  const { stopAudio, setCurrentAudio } = useAudio();
  const [aiWithCog, setAiWithCog] = useState(false);
  const current_book = useMemo(() => {
    return find(allBooks ?? [], ['id', bookId])?.subTopics || [];
  }, [allBooks, bookId]);
  const {currentBookData ={}} = useBook();
  const { isAiPermissionEnabled } = useUserProfileConfig();
  const classStudents = filter(classUsers, (user) => user.role === 'student');
  const [generationLoader, setGenerationLoader] = useState(false);
  const classTogglePermission = useClassTogglePermission();
  const bookOrder = useBookOrder();
  const isAdditionalBook = useIsAdditionalBook(bookId);
  const orgPermissions = useCurrentOrgPermission();

  // Check if cognates is allowed for the current book group
  const isCognatesAllowedForBookGroup = useMemo(() => {
    if (currentUser.role !== "student") return true; // Teachers always have access
    
    const currentBookGroup = bookOrder?.find(order => 
      order.order && order.order.includes(bookId)
    );

    if (!classTogglePermission.cognates) return true; // Default to allowed if no restrictions
    if (!has(classTogglePermission.cognates, currentBookGroup?.key || isAdditionalBook?.key)) return true;

    if (isAdditionalBook?.key) {
      if (orgPermissions[isAdditionalBook?.key]) {
        return classTogglePermission.cognates[isAdditionalBook?.key];
      }
    }
    // Check if cognates is allowed for this book group
    return classTogglePermission.cognates[currentBookGroup?.key];
  }, [currentUser.role, bookId, bookOrder, classTogglePermission.cognates, isAdditionalBook]);

  useEffect(() => {
    const updateWindowSize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    
    updateWindowSize();
    window.addEventListener("resize", updateWindowSize);
    return () => {
      window.removeEventListener("resize", updateWindowSize);
    };
  }, []);

  useEffect(() => {
    tabSelectorTypeRef.current = tabSelector?.type;
  }, [tabSelector?.type]);

  const handleTouch = (event) => {
    event.preventDefault();
    handleVocabularyClose();
  };

  const handleAudioChecker = async () => {
    stopAudio();
    setCurrentAudio(null);
    await dispatch(setAudioChecker({ isPlaying: false }));
  };

  useEffect(() => {
    const data = {
      teacher_id:
        currentUser.role == 'student'
          ? get(currentClass, 'teacherId', '')
          : get(currentUser, 'id', ''),
      user_id: get(currentUser, 'id', ''),
      created_by: currentUser.role == 'student' ? 'student' : 'teacher',
      class_id: currentUser.role == 'student' ? get(currentClass, 'id') : null,
      book_id: bookId,
    };
    Promise.allSettled([
      dispatch(handleListVocabularyCogantes(data, bookId, pageId, currentUser?.id)),
    ]);
  }, []);

useEffect(() => {
  if (!openVocabulary || currentUser?.role !== 'teacher' || !bookCognets?.length) return;
  if (tabSelector?.type === 'congantes') {
    const filterVocab = bookCognets?.filter((obj) => obj.page == pageId) || [];
    const filterByAdmin = filterVocab?.filter((data) => data?.created_by === 'owe_admin') || [];
    const filterByTeacher = filterVocab?.filter((data) => data?.created_by === 'teacher') || [];
    const filteredCognates = [...filterByAdmin, ...filterByTeacher];
    setSelectedWordCogantes(filteredCognates || []);
    return;
  }
  if (tabSelector?.type === 'unit_cognates') {
    if (!current_book || current_book?.length === 0) return;
    const unit = findPageObject(pageId, current_book);
    if (!unit) return;
    const filteredData = (bookCognets || []).filter((item) => {
      const pageNumber = parseInt(item.page, 10);
      return (
        pageNumber >= parseInt(unit?.startPage, 10) &&
        pageNumber <= parseInt(unit?.finishPage, 10)
      );
    });
    const filterByAdmin = filteredData?.filter((data) => data?.created_by === 'owe_admin') || [];
    const filterByTeacher = filteredData?.filter((data) => data?.created_by === 'teacher') || [];
    const data = [];
    if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
    if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
    setStudentCognates(data);
    setSelectedWordCogantes(data);
  }
}, [bookCognets, openVocabulary, pageId, tabSelector?.type, currentUser?.role, current_book])

  useEffect(() => {
    if (!assignmentAiModal) {
      questionRequestIdRef.current += 1;
      setQuestionGenerator([]);
      SetGenerateCount(0);
      setQuestionLoader(false);
      setGenerateQnALoader(false);
    }
  }, [assignmentAiModal]);

  const closeAlert = () => {
    setAlertSakeBar({ open: false, message: '', severity: 'success' });
  };
  const handleVocabularyClose = () => {
    handleAudioChecker();
    toogleChange('congantes');
    if (setVocModal) {
      setVocModal(false);
    }
    setVocabulary(false);
    setWordLanguage('english_to_spanish');
  };

  const toogleChange = (value) => {
    setTabSelector({ type: value });
  };

  useEffect(() => {
    if (isCheckingOpen) {
      setVocabulary(true);
      fetchStudentWordCounts();
    } else {
      setVocabulary(false);
    }
  }, [isCheckingOpen]);

  useEffect(() => {
    if (currentUser?.role === 'admin' && openVocabulary) {
      toogleChange('congantes');
    }
  }, [currentUser?.role, openVocabulary]);

  const handleGenerateMoreQnA = async (topic,key) => {
    try {
      const requestId = questionRequestIdRef.current + 1;
      questionRequestIdRef.current = requestId;
      if (!isAiPermissionEnabled) {
        showAlert('Please enable AI permission to generate questions.', 'error');
        return;
      }
      setQuestionLoader(true);
      const isNonNative = key === "english" && (!book || book?.book_type === 'non_native_spanish');
      const words = selectedWordCogantes.map((item) => item.data?.word_spanish);
      const data = words.join(", ");
       await handleStreamResponse({
            path: "ai/generate/generate-questions-for-vocab",
            body: JSON.stringify({
              topic: data,
              question_type: selectedTypes,
              language:
                wordLanguage === 'english_to_spanish'
                  ? 'spanish'
                  : wordLanguage === 'spanish_to_english'
                    ? 'english'
                    : '',
                generate_question_language: key,
                // is_non_native: isNonNative,
                is_cognate: true
            }),
            onTitle: (title) => {
              if (questionRequestIdRef.current !== requestId) return;
              setQnAWord(title)
              SetGenerateCount(0)
            },
            onQuestion: (question) => {
              if (questionRequestIdRef.current !== requestId) return;
              setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
              SetGenerateCount(prev => prev + 1)
              setQuestionLoader(false);
              setGenerateQnALoader(false);
            },
            onDone: () => {
              if (questionRequestIdRef.current !== requestId) return;
              setGenerateQnALoader(false);
              setQuestionLoader(false);
              SetGenerateCount(0)
            },
            onError: () => {
              if (questionRequestIdRef.current !== requestId) return;
              setGenerateQnALoader(false);
              setQuestionLoader(false);
              SetGenerateCount(0)
            }
          })
      // const generatedQuestionData = await dispatch(
      //   handleCreateVocabularyAIQnA({
      //     topic,
      //     language:
      //       wordLanguage === 'english_to_spanish'
      //         ? 'spanish'
      //         : wordLanguage === 'spanish_to_english'
      //           ? 'english'
      //           : '',
      //     question_type: selectedTypes,
      //   }),
      // );
      // if (generatedQuestionData?.data?.length >= 0) {
      //   setQuestionLoader(false);
      //   setQuestionGenerator(generatedQuestionData?.data);
      // } else {
      //   showAlert('something went wrong please try with another page!', 'error');
      // }
    } catch (error) {
      Sentry.captureException(`260 Error in handleGenerateMoreQnA: ${error}`);
      console.log(error);
      setGenerateQnALoader(false);
      setQuestionLoader(false);
      SetGenerateCount(0)
    }
  };

  const checkGenerateFromAi = async () => {
    try {
      const filterVocab = bookCognets?.filter((obj) => obj.page == pageId);
      const filterByAdmin = filterVocab?.filter((data) => data?.created_by === 'owe_admin') || [];
      const filterByTeacher = filterVocab?.filter((data) => data?.created_by === 'teacher') || [];
      const data = [...filterByAdmin, ...filterByTeacher];
      const isShowAiAlert = data.some((data) => data.is_ai === true);

      const dataAi = {
        bookId,
        page: pageId,
        chapter: bookId,
        created_by: currentUser?.role,
        user_id: get(currentUser, 'id', ''),
        class_id: get(currentClass, 'id', ''),
        language:
          wordLanguage === 'english_to_spanish'
            ? 'spanish'
            : wordLanguage === 'spanish_to_english'
              ? 'english'
              : '',
      };

      handleVocabularyClose();

      const proceedWithAI = async () => {
        setAiModal(true);
        let generatedCount = 0;
        setGenerationLoader(false);
        await handleStreamResponseForCognates({
          path: 'ai/generate-cognates-stream',
          body: dataAi,
          onFirstResponse: () => {
            setAiModal(false);
            setVocabulary(true);
            toogleChange('congantes');
            setGenerationLoader(true);
          },
          onCognate: (cog) => {
            if (cog && cog.id) {
              dispatch(createVocabularySuccessCogantes(cog))
            }
            generatedCount++;
          },
          onDuplicate: (dup) => {
          },
          onDone: () => {
            if (generatedCount === 0) {
              setAlertSakeBar({
                open: true,
                message: "This page doesn't contain any data.",
                severity: 'error',
              });
            }
            setGenerationLoader(false);
          },
          onError: (err) => {
            setGenerationLoader(false);
            setAiModal(false);
            setAlertSakeBar({
              open: true,
              message: "Something went wrong, please try again later.",
              severity: 'error',
            });
            console.error('Error in AI stream:', err);
          }
        })
      };

      if (isShowAiAlert) {
        confirm({
          title: 'Confirm',
          content: `You've already generated contents on this page. Are you sure you want to regenerate them?`,
          okText: 'Continue',
          okButtonProps: {
            className: 'force-blue-button',
            style: {
              backgroundColor: '#012B70 !important',
              borderColor: '#012B70 !important',
            },
          },
          onOk: async (close) => {
            close();
            await proceedWithAI();
          },
          onCancel: () => {
            setVocabulary(true);
            toogleChange('congantes');
          }, // Do nothing on cancel
        });
      } else {
        await proceedWithAI(); // Call API directly if no alert is needed
      }
    } catch (error) {
      Sentry.captureException(`261 Error in checkGenerateFromAi: ${error}`);
      console.log(error);
    }
  };

  const handleCheckboxChangeForCogantes = (checked, value) => {
    if (checked) {
      setSelectedWordCogantes((prev) => [...prev, value]);
    } else {
      setSelectedWordCogantes((prev) => prev.filter((item) => item.id !== value.id));
    }
  };

  const handleCreateVocabularyQnACogantes = async (wordSelected, count = 0, maxAttempts = 1) => {
    try {
      const requestId = questionRequestIdRef.current + 1;
      questionRequestIdRef.current = requestId;
      if (!isAiPermissionEnabled) {
        showAlert('Please enable AI permission to generate content using AI.', 'error');
        return;
      }
      let words = [];
      if (wordSelected === 'spanish') {
        words = selectedWordCogantes.map((item) => item.data?.word_spanish);
      } else if (wordSelected === 'english') {
        words = selectedWordCogantes.map((item) => item.data?.word_english);
      }

      const data = words.join(', ');
      if (selectedWordCogantes?.length === 0 || data === '')
        return showAlert('Select atleast one Cognates', 'error');

      if (count === 0) {
        setAssignmentAiModal(true);
        setGenerateQnALoader(true);
        handleVocabularyClose();
      }
      const isNonNative = wordSelected === "english" && (!book || book?.book_type === 'non_native_spanish');
         await handleStreamResponse({
            path: "ai/generate/generate-questions-for-vocab",
           body: JSON.stringify({
             topic: data,
             language:
               wordSelected === 'spanish' ? 'spanish' : wordSelected === 'english' ? 'english' : '',
               generated_question_language: wordSelected?.toLowerCase(),
              //  is_non_native: isNonNative,
               is_cognate: true
           }),
            onTitle: (title) => {
            if (questionRequestIdRef.current !== requestId) return;
              setQnAWord(title)
              SetGenerateCount(0)
            },
            onQuestion: (question) => {
            if (questionRequestIdRef.current !== requestId) return;
              setQuestionGenerator(prev => [...prev, { ...question, id: Math.random() * 1000000000 }]);
              SetGenerateCount(prev => prev + 1)
              setQuestionLoader(false);
              setGenerateQnALoader(false);
            },
            onDone: () => {
            if (questionRequestIdRef.current !== requestId) return;
              setGenerateQnALoader(false);
              setQuestionLoader(false);
              SetGenerateCount(0)
            },
            onError: () => {
            if (questionRequestIdRef.current !== requestId) return;
              setGenerateQnALoader(false);
              setQuestionLoader(false);
              SetGenerateCount(0)
            }
          })
      
      // const generatedQuestionData = await dispatch(
      //   handleCreateVocabularyAIQnA({
      //     topic: data,
      //     language:
      //       wordSelected === 'spanish' ? 'spanish' : wordSelected === 'english' ? 'english' : '',
      //   }),
      // );

      // if (generatedQuestionData?.data?.length >= 0) {
      //   setGenerateQnALoader(false);
      //   setQuestionGenerator(generatedQuestionData?.data);
      //   setQnAWord(data);
      // } else {
      //   if (count < maxAttempts) {
      //     await handleCreateVocabularyQnACogantes(wordSelected, count + 1, maxAttempts);
      //     return;
      //   }
      //   showAlert('Please try again later!', 'error');
      //   setAssignmentAiModal(false);
      //   setGenerateQnALoader(false);
      // }
    } catch (error) {
      Sentry.captureException(`262 Error in handleCreateVocabularyQnACogantes: ${error}`);
      console.log(error);
    }
  };

  const onCallStudentVocab = async (id, type) => {
    const targetTab = type === 'vocabulary' ? 'my_vocab_stud' : 'my_student_cog';
    setVocLoader(true);
    const data = {
      teacher_id: get(currentUser, 'id', ''),
      user_id: id,
      created_by: 'teacher_student',
      page: pageId,
      book_id: bookId,
    };
    try {
      const selectedStudentCognate = await dispatch(
        handleListVocabularyCogStud(data, bookId, pageId, currentUser?.id),
      );
      const cognateList = Array.isArray(selectedStudentCognate) ? selectedStudentCognate : [];
      if (tabSelectorTypeRef.current !== targetTab) {
        return;
      }
      setStudentCognates(cognateList);
      setSelectedWordCogantes(cognateList);
    } finally {
      setVocLoader(false);
    }
  };


     const fetchStudentWordCounts = async (pageSpecific = true) => {
        try {
          setLoading(true);
          const classId = get(currentClass, 'id');
  
          if (!classId || !bookId) {
            console.warn('Missing required parameters:', { classId, bookId });
            setStudentWordCounts([]);
            setLoading(false);
            return [];
          }
  
          const data = {
            class_id: classId,
            book_id: bookId,
            type: "cognates",
            ...(pageSpecific && { page: pageId }),
          };
  
          const counts = await dispatch(handleGetStudentWordCount(data));
          if (Array.isArray(counts)) {
            setLoading(false);
            setStudentWordCounts(counts);
            return counts;
          } else {
            setLoading(false);
            setStudentWordCounts([]);
            return [];
          }
        } catch (error) {
          console.error('Error fetching student word counts:', error);
          setStudentWordCounts([]);
          setLoading(false);
          return [];
        }
      };

  const StudentVocabulary = ({ type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

     const getStudentWordCount = (studentId) => {
         if (!Array.isArray(studentWordCounts)) {
              return 0;
          }
        const student = studentWordCounts.find(s => s.id === studentId);
        return student ? student.word_count : 0;
    };

    const items =
      classStudents?.map((item) => ({
        key: item.id,
        label: `${item.firstName} ${item.lastName}`,
        wordCount: getStudentWordCount(item.id)
      })) || [];

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    const handleItemClick = (key) => {
      toogleChange('my_student_cog');
      onCallStudentVocab(key, type);
      setIsOpen(false);
    };

    return (
      <SentryWrap>
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <Button
          className={`minWith ${tabSelector?.type === (type === 'vocabulary' ? 'my_vocab_stud' : 'my_student_cog') ? 'selected selected-background-color' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          Student Cognates
          {isOpen ? (
            <KeyboardArrowUp style={{ marginRight: -5 }} />
          ) : (
            <KeyboardArrowDown style={{ marginRight: -5 }} />
          )}
        </Button>

        {isOpen && (
          <div
            data-dropdown="true"
            className="dropdown-scrollable"
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: '#fff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              borderRadius: '4px',
              zIndex: 1000,
              minWidth: '200px',
              maxHeight: '200px',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
              touchAction: 'pan-y'
            }}
          >
            {items.map((item) => (
              <div
                key={item.key}
                onClick={() => handleItemClick(item.key)}
                style={{
                    padding: '8px 12px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    ':hover': {
                                        backgroundColor: '#f5f5f5'
                                    }
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
              >
                {item.label}
                  <span
                  style={{
                    backgroundColor: '#5d4187',
                    color: 'white',
                    borderRadius: '12px',
                    padding: '2px 8px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    minWidth: '20px',
                    textAlign: 'center',
                  }}
                >
                  {item.wordCount}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
      </SentryWrap>);
  };

  const findPageObject = (pageID, data) => {
    return data.find(
      (item) =>
        Number(pageID) >= Number(item.startPage) && Number(pageID) <= Number(item.finishPage),
    );
  };

  const onManageCognatesMenu = async (id) => {
    if (id === 'cognate') {
      setTabSelector({ type: id === 'cognate' ? 'congantes' : 'unit_cognates' });
      setSelectedWordCogantes(selectedWordCogantes);
    } else if (id === 'unit_cognates') {
      if (current_book?.length === 0) {
        showAlert('Unit not found in this book.', 'error');
        return;
      }
      setTabSelector({ type: id === 'cognate' ? 'congantes' : 'unit_cognates' });
      const findUnit = findPageObject(pageId, current_book);
      const filteredData = bookCognets.filter((item) => {
        const pageNumber = parseInt(item.page, 10);
        return (
          pageNumber >= parseInt(findUnit.startPage, 10) &&
          pageNumber <= parseInt(findUnit.finishPage, 10)
        );
      });
      const filterByAdmin = filteredData?.filter((data) => data?.created_by === 'owe_admin') || [];
      const filterByTeacher = filteredData?.filter((data) => data?.created_by === 'teacher') || [];
      const data = [];
      if (filterByAdmin?.length > 0) data.push(...filterByAdmin);
      if (filterByTeacher?.length > 0) data.push(...filterByTeacher);
      setStudentCognates(data);
      setSelectedWordCogantes(data);
    }
  };

  const AllCognates = ({ type }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const items = [
      {
        key: 'cognate',
        label: 'Page Cognates',
      },
      location.pathname === '/ebook' && currentBookData?.structures?.length > 0 &&{
              key: 'unit_cognates',
              label: 'Unit Cognates',
            },
    ];

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, []);

    const handleItemClick = (key) => {
      onManageCognatesMenu(key, type);
      setIsOpen(false);
    };

    return (
      <div ref={dropdownRef} style={{ position: 'relative' }}>
        <Button
          className={`minWith ${tabSelector?.type === 'congantes' || tabSelector?.type === 'unit_cognates' ? 'selected selected-background-color' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {tabSelector?.type === 'congantes'
            ? 'Page Cognates'
            : tabSelector?.type === 'unit_cognates'
              ? 'Unit Cognates'
              : 'Cognates'}
          {isOpen ? (
            <KeyboardArrowUp style={{ marginRight: -5 }} />
          ) : (
            <KeyboardArrowDown style={{ marginRight: -5 }} />
          )}
        </Button>

        {isOpen && (
          <div
            data-dropdown="true"
            className="dropdown-scrollable"
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              backgroundColor: '#fff',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              borderRadius: '4px',
              zIndex: 1000,
              minWidth: '200px',
              maxHeight: '200px',
              overflowY: 'auto',
              WebkitOverflowScrolling: 'touch',
              touchAction: 'pan-y'
            }}
          >
            {items.map((item) => (
              <div
                key={item.key}
                onClick={() => handleItemClick(item.key)}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  transition: 'background-color 0.3s',
                  ':hover': {
                    backgroundColor: '#f5f5f5',
                  },
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f5f5f5')}
                onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#fff')}
              >
                {item.label}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const RenderMenuContent = () => {

    return {
      items: [
        // Teacher Menu Items
        ...(get(currentUser, 'role') === 'teacher'
          ? [
              {
                key: 'cognate',
                label: 'Page Cognates',
                onClick: () => onManageCognatesMenu('cognate'),
              },
            ]
          : []),
        ...(get(currentUser, 'role') === 'teacher' && location?.pathname === '/ebook'
          ? [
              {
                key: 'unit_cognates',
                label: 'Unit Cognates',
                onClick: () => onManageCognatesMenu('unit_cognates'),
              },
            ]
          : []),
        ...(get(currentUser, 'role') === 'teacher' && !isExam && !isOnlyForTeacher
          ? [
              {
                key: 'cognates_with_ai',
                label: 'Cognates with AI',
                onClick: () => checkGenerateFromAi(),
              },
            ]
          : []),
        ...(currentUser?.role === 'teacher' && !isExam && !isOnlyForTeacher
          ? [
              {
                key: 'ai_with_cog',
                label: (
                  <div onClick={() => setAiWithCog((prev) => !prev)}>
                    AI Act. with Cognates {aiWithCog ? <UpOutlined /> : <DownOutlined />}
                  </div>
                ),
                children: aiWithCog
                  ? [
                      {
                        key: 'ai_cog_english',
                        label: 'AI Act. with Cognates in English',
                        onClick: () => {
                          handleCreateVocabularyQnACogantes('english');
                        },
                      },
                      {
                        key: 'ai_cog_spanish',
                        label: 'AI Act. with Cognates in Spanish',
                        onClick: () => {
                          handleCreateVocabularyQnACogantes('spanish');
                        },
                      },
                    ]
                  : [],
              },
            ]
          : []),

        ...(get(currentUser, 'role') === 'student'
          ? [
              {
                key: 'congantes',
                label: 'Cognates',
                onClick: () => toogleChange('congantes'),
              },
            ]
          : []),
        ...(get(currentUser, 'role') === 'student'
          ? [
              {
                key: 'my_cogants',
                label: 'My Cognates',
                onClick: () => toogleChange('my_cogants'),
              },
            ]
          : []),
      ],
    };
  };

  return (
    <SentryWrap>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: '' });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      <CognateAiLoader aiModal={aiModal} />
      {/* {isCognatesAllowedForBookGroup && ( */}
      <Button
        style={{
          borderRadius: '0px !important',
          minWidth: 'unset',
          height: '36px',
          marginLeft: currentUser?.role === 'student' && 0,
          ...(style ? style : {}),
        }}
        onClick={() => {
          closeToolsDropdown();
          setVocabulary(!openVocabulary);
          fetchStudentWordCounts();
        }}
        className={`${currentUser?.role === 'student' && 'ml-0px'} vocabularyBtn vocDeskTab ${vocabilaryButtonClassName}`}
      >
        Cognates
      </Button>
      {/* )} */}
      {openVocabulary && (
            <ResizeAndDragabble
              style={{zIndex: 999999999}}
              defaultValue={{
                x: windowSize?.width < 768 ? (windowSize?.width - windowSize?.width * 0.7) / 2 : (windowSize?.width - Math.min(windowSize?.width - 40, 700)) / 2,
                y: windowSize?.height < 600 ? 10 : (windowSize?.height - Math.min(windowSize?.height - 40, 500)) / 2,
                width: windowSize?.width < 768 ? windowSize?.width * 0.7 : Math.min(windowSize?.width - 40, 700),
                height: windowSize?.height < 600 ? windowSize?.height * 0.7 : Math.min(windowSize?.height - 40, 500),
              }}
              size={dimensions?.width && dimensions?.height ? dimensions : undefined}
              minHeight={200}
              minWidth={windowSize?.width < 768 ? windowSize?.width * 0.5 : 300}
              maxWidth={windowSize?.width < 768 ? windowSize?.width : windowSize?.width - 40}
              maxHeight={windowSize?.width < 768 ? windowSize?.height * 0.8 : windowSize?.height - 60}
              resize={(data) => setDimensions(data)}
              resizeEnd={(data) => setDimensions(data)}
              aspectRatio={false}
            >
              <ModalContent isLandscape={isLandscape} className="vocabulContents cognatesNonSpanishWidget" style={{
                boxShadow: "rgba(0, 0, 0, 0.2) 0px 2px 4px",
                zIndex: 999999999,
                position: "relative"
              }}>

               

                <div className="checkListFirstTxt absolute top-0 w-full pt-17px pb-14px br-topLeft-topRight-20px" style={{ pointerEvents: 'none' }}>
                  <span className="text-white text-ft12-700 vocabularyTrack">Cognates</span>
                </div>

                {showAccordin && (
                  <CrossPrint style={{ pointerEvents: 'auto' }} className='genCognatesForLoader'>

                    <LoaderArea className='genCognatesCstm'>
                      {generationLoader && <label>Generating Cognates</label>}
                      <ItemLoader loading={generationLoader} /> 
                    </LoaderArea>

                    <div className='addNoSpnshIcns'>
                    <AIUsageInfo />
                    {get(currentUser, 'role') === 'teacher' && (
                      <div>
                        <VocabPrint
                          data={
                            tabSelector?.type === 'congantes'
                              ? selectedWordCogantes
                              : tabSelector?.type === 'unit_cognates'
                                ? studentCognates
                                : tabSelector?.type === 'my_student_cog'
                                  ? studentCognates
                                  : []
                          }
                          toggleType={tabSelector?.type}
                          vocType="nonSpanish"
                        />
                      </div>
                    )}
                    <Close color="secondary" onClick={handleVocabularyClose} className="vocabulClose" />
                    </div>
                    
                  </CrossPrint>
                )}
                <div className='VocabularyTabWidget VocabularyTab FirstVocabularyTab flex items-stretch gap-5px flex-wrap mr-26px' style={{ pointerEvents: 'auto' }}>
                {get(currentUser, 'role') === 'teacher' && <AllCognates />}
                {currentUser?.role === 'admin' && (
                  <Button
                    className={`minWith selected selected-background-color`}
                  >
                    Page Cognates
                  </Button>
                )}
                  {get(currentUser, 'role') === 'student' && (
                    <Button
                      className={
                        tabSelector?.type === 'congantes' ? 'selected selected-background-color' : ''
                      }
                      onClick={() => {
                        toogleChange('congantes');
                        setSelectedWordCogantes(selectedWordCogantes);
                      }}
                    >
                      Cognates
                    </Button>
                  )}
                  {get(currentUser, 'role') === 'student' && (
                    <Button
                      className={`minWith ${tabSelector?.type === 'my_cogants' ? 'selected selected-background-color' : ''}`}
                      onClick={() => toogleChange('my_cogants')}
                    >
                      My Cognates
                    </Button>
                  )}
                  <CreateQuestionAndAnswerForAICogantes
                    toogleChange={toogleChange}
                    data={{ currentUser, isExam, isOnlyForTeacher }}
                    addNewItem={handleCreateVocabularyQnACogantes}
                  />
                  {get(currentUser, 'role') === 'teacher' && !isExam && !isOnlyForTeacher && (
                    <Button
                      className="minWith create-with-ai-button"
                      onClick={() => checkGenerateFromAi()}
                    >
                      Cognates with AI
                    </Button>
                  )}
                  {loading ? <Loading size={16} /> : get(currentUser, 'role') === 'teacher' && <StudentVocabulary type="cognates" />}
                </div>
                <div className='vocabulTableUpr vocab-table-upar vocInMobile vocabStrokeWidth dropdown-scrollable cursor-default' data-dropdown="true" ref={vocabdomRef}>
                  {(tabSelector?.type === 'congantes' ||
                    tabSelector?.type === 'my_cogants' ||
                    tabSelector?.type === 'my_student_cog' ||
                    tabSelector?.type === 'unit_cognates') && (
                    <Cogantes
                      studentCognates={studentCognates}
                      selectedWordCogantes={selectedWordCogantes}
                      setSelectedWordCogantes={setSelectedWordCogantes}
                      handleCheckboxChangeForCogantes={handleCheckboxChangeForCogantes}
                      non_native={true}
                      tabSelector={tabSelector}
                      refs={{ vocabdomRef }}
                      stopAudio={stopAudio}
                      bookId={bookId}
                      pageId={pageId}
                      vocLoader={vocLoader}
                      isCognatesAllowedForBookGroup={isCognatesAllowedForBookGroup}
                    />
                  )}
                </div>
              </ModalContent>
            </ResizeAndDragabble>
      )}
      {assignmentAiModal && (
        <QnALoader
          assignmentAiModal={assignmentAiModal}
          setAssignmentAiModal={setAssignmentAiModal}
          handleGenerateMoreQnA={handleGenerateMoreQnA}
          generateQnALoader={generateQnALoader}
          questionGenerator={questionGenerator}
          page={pageId}
          chapter={bookId}
          qnaWord={qnaWord}
          loading={questionLoader}
          pageNumber={pageNumber}
          setSelectedTypes={setSelectedTypes}
          selectedTypes={selectedTypes}
          generatedCount={generatedCount}
          setQuestionGenerator={setQuestionGenerator}
        />
      )}
    </SentryWrap>
  );
};

export default CognatesNonSpanishComponent;
